<!-- 领取核销码页面 -->
<template>
  <div>
    <div class="welfareDetailsDiv">
      <div class="profiles">
        {{ this.welfare.service }}
      </div>
      <div class="dispalyImgDiv">
        <img :src="this.welfare.img" alt="展示图片" class="dispalyImg" />
      </div>
      <div class="welfareCardDiv">
        <img src="../../assets/image/welfareDetails.png" alt="背景图片" class="welfareCardImg" />
        <div class="welfareCard">
          <div class="adressName">{{ this.welfare.schoolName }}</div>
          <div class="welfareSupport">
            校 &nbsp;&nbsp; 友：{{ this.welfare.name }}
          </div>
          <div class="contacts">
            联系人：{{ this.welfare.contact }}
            <a :href="this.contactsTel"><img src="../../assets/image/btn_dianhua_nor.png" alt="电话"
                class="telIcon" /></a>
          </div>
          <div class="adress">
            地 &nbsp;&nbsp; 点：{{ this.welfare.address }}
          </div>
          <div class="wechat">
            微 &nbsp;&nbsp; 信：{{ this.welfare.wechat }}
          </div>
        </div>
        <div class="welfareProfilesDiv">
          <div class="welfareProfiles" id="welfareProfilesId"></div>
        </div>
        <div class="icon"></div>
        <div class="btnDiv">
          <button class="btn" @click="showWelfare" v-if="this.welfare.status == 3">
            立即领取
          </button>
          <button class="btn" v-else-if="this.welfare.status == 2" @click="gotoActiveCode()">
            核销码
          </button>
          <button class="btn" v-else-if="this.welfare.status == 1">已使用</button>
          <button class="btn" v-else>暂时无法使用</button>
        </div>
        <!-- 福利领取成功弹窗 -->
        <div class="welfarePopup">
          <!-- @open打开弹出层时触发 -->
          <van-popup v-model="welfareShow" round :style="{ height: '50%', width: '90%' }">
            <div class="topImgDiv">
              <img src="../../assets/image/btn_shang_nor.png" alt="顶部图片" class="topImg" />
            </div>
            <div class="popupExplain">领取成功</div>
            <div class="popupWelfareExplainWords">
              <div class="popupWelfareName">
                {{ this.welfare.schoolName }}
              </div>
              <div class="popupWelfareAdress">
                地点：{{ this.welfare.address }}
              </div>
              <div class="popupWelfareService">
                服务：{{ this.welfare.service }}
              </div>
            </div>
            <div class="popupWelfareTips">请在：我的-券包 中查看核销码</div>
            <div class="popupWelfareBtnDiv">
              <button class="popupBtn" @click="closeWelfarePopup">
                知道了
              </button>
            </div>
            <div class="bottomImgDiv">
              <img src="../../assets/image/btn_xia_nor.png" alt="底部图片" class="bottomImg" />
            </div>
          </van-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      welfare: "",
      welfareShow: false,
      welfareSucc: "",
      welfareData: "",
      //welfareStatus: '',
      contactsTel: "",
      user_id: window.localStorage.getItem("user_id"),
    };
  },
  created() {
    this.getWelfare();
    //this.getWelfareStatus();
  },
  methods: {
    async getWelfare() {
      const result = await this.$http.get("/alumniCard/getSchoolHomeById", {
        params: {
          wId: this.$route.query.wId,
          userId: window.localStorage.getItem("user_id"),
        },
      });
      this.welfare = result.data;
      this.contactsTel = "tel" + ":" + this.welfare.telephone;
      document.getElementById("welfareProfilesId").innerHTML =
        this.welfare.content;
    },
    /* async getWelfareStatus() {
      const result = await this.$http.get("/alumniCard/getWelfareLog", {
        params: {
          wId: this.$route.query.wId,
          userId: this.user_id
        },
      });
      this.welfareStatus = result.data;
    }, */
    async receiveWelfare() {
      const result = await this.$http({
        url: "/alumniCard/insertWelfareInfo",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          userId: this.user_id,
          wId: this.$route.query.wId,
          url: window.localStorage.getItem("WelfarelUrl")
        }),
      });
      /*  this.welfareSucc = result.data;
       this.welfareData = result.data.data; */
      if (result.data.领取福利成功 == true) {
        this.welfareShow = true;
      } else {
        this.$toast(result.data.msg);
      }
    },
    showWelfare() {
      this.receiveWelfare();
    },
    closeWelfarePopup() {
      this.welfareShow = false;
      location.reload();
    },
    gotoActiveCode() {
      return this.$router.push({ path: "/activeCode", query: { wid: this.$route.query.wId } });
    },
  },
};
</script>
<style lang="less" scoped>
.welfareDetailsDiv {
  position: relative;
}

.profiles {
  position: absolute;
  top: 0%;
  width: 100%;
  background-color: #000000;
  opacity: 0.6;
  color: white;
  padding: 5px 0px 5px 10px;
}

.dispalyImgDiv {
  width: 100%;
  height: 40vh;

  .dispalyImg {
    width: 100%;
    height: 100%;
  }
}

.welfareCardDiv {
  position: absolute;
  top: 50%;
}

.welfareCardImg {
  width: 100vw;
  height: 73vh;
}

.welfareCard {
  position: absolute;
  top: 8%;
  width: 90%;
  left: 5%;
  background-color: white;
  border-radius: 15px;
}

.adressName {
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
  padding: 10px 0px 5px 10px;
}

.welfareSupport,
.contacts {
  color: #666666;
  padding: 5px 0px 5px 10px;
}

.adress {
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.wechat {
  color: #666666;
  padding: 5px 0px 15px 10px;
}

.welfareProfilesDiv {
  position: absolute;
  top: 42%;
  width: 90%;
  left: 5%;
  background-color: white;
  border-radius: 15px;
  height: 46%;
  overflow-y: scroll;
}

.welfareProfilesDiv::-webkit-scrollbar {
  display: none;
}

.welfareProfiles {
  position: relative;
  left: 3%;
  width: 94%;
}

.icon {
  position: absolute;
  top: 88%;
  background-color: #8ebeff;
  height: 10px;
  width: 80%;
  left: 10%;
  border-radius: 0px 0px 15px 15px;
}

.btnDiv {
  text-align: center;
}

.btn {
  border: 0;
  color: #00706E;
  background-color: #f5f5f5;
  font-size: 1.3em;
  font-weight: bold;
  padding-top: 5px;
}

.topImgDiv {
  width: 100%;
}

.topImg {
  width: 100%;
}

.bottomImgDiv {
  width: 100%;
}

.bottomImg {
  width: 100%;
  position: absolute;
  top: 100%;
  transform: translateY(-100%);
}

.popupExplain {
  font-size: 1.2em;
  color: #00706E;
  text-align: center;
  font-weight: bold;
}

.popupWelfareExplainWords {
  position: relative;
  left: 5%;
  top: 5%;
  width: 90%;
  overflow-y: scroll;
  background-color: #f5f5f5;
  border-radius: 15px;
}

.popupWelfareName {
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
  padding: 10px 0px 5px 10px;
}

.popupWelfareAdress {
  color: #666666;
  padding: 5px 0px 5px 10px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.popupWelfareService {
  color: #666666;
  padding: 5px 10px 10px 10px;
}

.popupWelfareTips {
  position: relative;
  top: 15%;
  text-align: center;
  font-size: 1.1em;
  color: #333333;
  font-weight: bold;
}

.popupWelfareBtnDiv {
  position: absolute;
  top: 72%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}

.popupBtnDiv {
  position: absolute;
  top: 82%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
}

.popupBtn {
  width: 100%;
  border: 0;
  background: linear-gradient(270deg, #00706E, #00706E);
  font-size: 1.2em;
  font-weight: bold;
  color: white;
  padding: 8px 0 8px 0;
  border-radius: 45px;
}

.telIcon {
  width: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniCard/WelfareDetails.vue